import kotlinx.coroutines.suspendCancellableCoroutine
import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Int8Array
import org.khronos.webgl.get
import org.w3c.files.File
import org.w3c.files.FileReader
import kotlin.coroutines.resume
import kotlin.coroutines.resumeWithException

/** Přečte obsah souboru (z <input type=file>) jako ByteArray pro upload do Storage. */
suspend fun readFileBytes(file: File): ByteArray = suspendCancellableCoroutine { cont ->
    val reader = FileReader()
    reader.onload = {
        val buffer = reader.result as ArrayBuffer
        val view = Int8Array(buffer)
        cont.resume(ByteArray(view.length) { view[it] })
    }
    reader.onerror = { cont.resumeWithException(RuntimeException("Načtení souboru selhalo")) }
    reader.readAsArrayBuffer(file)
}

/** Bezpečný název souboru: přípona z typu obsahu, jinak z názvu; jen [a-z0-9.] . */
fun mediaFileName(prefix: String, file: File): String {
    val ext = when (file.type) {
        "image/png" -> "png"
        "image/jpeg" -> "jpg"
        "image/webp" -> "webp"
        "image/gif" -> "gif"
        else -> file.name.substringAfterLast('.', "jpg").lowercase()
    }
    val safeExt = ext.filter { it.isLetterOrDigit() }.ifBlank { "jpg" }
    return "$prefix-${kotlin.js.Date().getTime().toLong()}.$safeExt"
}
